import ServiceExec from '@/common/utils/ServiceExec';
import { user } from '@/common/service/apiList';
import { ACCESS_TOKEN_NAME, REFRESH_TOKEN_NAME } from '@/common/constants/ConstCode';
import { asFormData, fileRequestBinding, isEmpty, REMOVE_EMPTY_PARAMS } from '@/common/utils/Util';
import store, { resetStoreOnLogout } from '@/store';
import { setSocialJoinBlock } from '@/common/utils/module/SocialJoinBlock';
import { markRecentLogin } from '@/common/utils/module/RecentLogin';
import { cloneDeep } from 'lodash';
import qs from 'query-string';
// 260916: signOut 재진입 가드 — 401/500 전역 핸들러가 signOut 을 다시 부르며 PATCH /api/user/log/out 을 초당 40건 반복하던 루프 차단(운영 12:24 실사고).
let signOutInFlight = false;
// 260926: renewFcmToken 직렬화 꼬리(부팅·로그인 동시 호출 → 중복 INSERT 방지)
let fcmRenewTail = Promise.resolve();
const {
  signUp,
  logIn,
  logOut,
  deleteUser,
  canDeleteUser,
  renewAccessToken,
  authCode,
  familyCodeSearch,
  emailDuplicated,
  findId,
  editPassword,
  updateUser,
  findIdAuthCode,
  joinAuthCode,
  findPasswordCode,
  userItemCount,
  userFamilyList,
  editMarketing,
  deathCertificate,
  userIdExists,
  renewFcmToken,
  editBusinessMarketing,
  premiumNumberCheck,
  updateUserPremium,
  versionCheck,
  smsVerify
} = user;

export default {
  // 260923 대표: 메가커피 이벤트 중단 — 가입 payload 의 eventCode(추천·행사 코드) 전달을 걷어냈다.
  signUp: async ({ commit, getters }, { isFamilyRepresent, joinType }) => {
    const payload = cloneDeep(getters['getSignUp']);

    payload.form.isFamilyRepresent = isFamilyRepresent;
    payload.form.joinType = joinType;
    payload.form.deviceInfo = getters['getDeviceInfo'];
    payload.form.isPremium = getters['getIsPremium'];
    payload.form.couponNumber = getters['getCouponNumber'];

    // 260513 리텐션 보드: 채널 ROI용 utm_source 첨부 (App.vue onMounted에서 캐치 후 localStorage 저장)
    try {
      const utm = window.localStorage.getItem('jump_utm_source');
      if (utm) payload.form.utmSource = utm;
    } catch (_) {
      /* localStorage 차단 환경 무시 */
    }

    delete payload.form?.email;
    const { status, data } = await ServiceExec.post(signUp, REMOVE_EMPTY_PARAMS(payload.form));
    if (status === ServiceExec.status.OK) {
      console.log('회원가입 성공', payload.form);
      await store.dispatch('user/signIn', payload.form);
      return true;
    }
    // 260812: 409 = 번호 기가입 차단. 로그인 단계에서 걸렀어야 할 건이 여기까지 온 경우(provider 일시
    //   오류로 그때 번호를 못 얻었을 때)라, SMS 스텝으로 되돌려 '다른 번호로 가입'을 열어주면 안 된다.
    //   호출부가 그 분기를 끊을 수 있게 판정 결과를 실어 보낸다(문구는 종전처럼 문자열로 반환).
    if (status === ServiceExec.status.CONFLICT && data?.message) {
      setSocialJoinBlock(data);
      return data.message;
    }
    // 260807: 실패 사유를 삼키지 않는다. BE는 ServiceException 메시지를 평문 문자열로 내려주는데
    //   (ControllerAdvisorConfig.handleServiceException) 여기서 버려서, 화면엔 원인과 무관하게
    //   항상 "회원 가입에 실패하였습니다."만 떴다. '이미 카카오로 가입된 번호예요' 같은 안내가
    //   사용자에게 닿아야 다음 행동을 안다. 호출부(SignUp.vue)는 `!== true`로 성공을 판정한다.
    return typeof data === 'string' && data ? data : false;
  },
  signIn: async ({ commit, getters, dispatch }, form) => {
    form.deviceInfo = null;
    // 260812: 직전 시도의 차단 안내가 남아 다음 로그인에 새어나가지 않게 매 호출 초기화한다.
    setSocialJoinBlock(null);
    const { status, data, headers } = await ServiceExec.patch(logIn, form);
    if (status !== ServiceExec.status.OK) {
      // 260812: 실패에는 두 종류가 있는데 예전엔 둘 다 false여서 호출부가 전부 '미가입 → 회원가입'으로 보냈다.
      //   ① 그냥 계정 없음 → 가입 유도(기존 동작)
      //   ② 409 SOCIAL_PHONE_ALREADY_JOINED = 그 소셜의 번호가 이미 다른 경로로 가입됨 → 가입 진입 자체를 막아야 한다.
      //   반환값은 false 그대로 둔다 — 문자열/객체를 돌려주면 `if (await signIn)`을 쓰는 호출부가
      //   로그인 성공으로 오인해 홈으로 보낸다. 판정 결과는 모듈에 실어 보낸다.
      if (status === ServiceExec.status.CONFLICT) setSocialJoinBlock(data);
      return false;
    }

    commit('storeLogin', {
      userData: data,
      accessToken: headers[ACCESS_TOKEN_NAME],
      refreshToken: headers[REFRESH_TOKEN_NAME]
    });

    const deviceInfo = getters['getDeviceInfo'];
    deviceInfo.userNo = data.userNo;
    console.log('디바이스', deviceInfo);
    commit('setDeviceInfo', deviceInfo);
    // 260926: 로그인(가입 직후 포함)마다 이 기기의 푸시 토큰을 이 계정에 등록 — 위 renewFcmToken 주석. 로그인 흐름은 기다리지 않는다.
    if (deviceInfo?.pushToken) dispatch('renewFcmToken').catch(() => {});
    store.commit('user/setFirstLogin', true);
    // 260914: 로그인 화면 '최근 로그인' 말풍선용. 응답의 joinType(BE 정본)을 우선, 없으면 요청 폼 값.
    markRecentLogin(data?.joinType || form?.joinType);
    return true;
  },

  // 진행중 초대관/장례식장 유무 판정은 BE만 신뢰한다.
  // 로그인 정보 부재/네트워크/인증 오류는 "초대관·장례식장 있음"과 무관하므로 false로 뭉뚱그리지 않고
  // throw로 호출부에 전파해 정확한 안내를 띄우게 한다. (false 폴백 시 오탐 차단 발생 — 260623)
  canDeleteUser: async ({ getters }) => {
    const { userNo } = getters['getUserData'];
    if (isEmpty(userNo)) throw new Error('canDeleteUser: missing userNo');

    const response = await ServiceExec.get(canDeleteUser(userNo));
    return response?.data === true;
  },

  deleteUser: async ({ commit, getters }, reason) => {
    const { userNo } = getters['getUserData'];
    const { status, data } = await ServiceExec.post(deleteUser, { userNo, reason });
    if (status !== ServiceExec.status.OK) return false;
    return data;
  },

  // 260424 오후: 회원가입/소셜 가입 직후 관심 카테고리 저장
  saveInterestCategories: async (_, categoryNos) => {
    const { status, data } = await ServiceExec.post(
      '/api/user/interest-category',
      { categoryNos: Array.isArray(categoryNos) ? categoryNos : [] }
    );
    if (status !== ServiceExec.status.OK) return null;
    return data;
  },

  // 260630 C: 관심사 설문 상태/prefill. {completed, categoryNos, answers}. 가입 직후 프롬프트 판정용.
  getInterestSurvey: async () => {
    try {
      const { status, data } = await ServiceExec.get('/api/user/interest-category/survey');
      if (status !== ServiceExec.status.OK) return null;
      return data ?? null;
    } catch (e) { return null; }
  },

  // 260630 C: 관심사 설문 저장. answers(취향)만 보내면 관심 업종은 유지(가입 step7 수집분). categoryNos 보내면 교체.
  saveInterestSurvey: async (_, { categoryNos = null, answers = {} }) => {
    try {
      const body = { answers };
      if (Array.isArray(categoryNos)) body.categoryNos = categoryNos;
      const { status, data } = await ServiceExec.post('/api/user/interest-category/survey', body);
      if (status !== ServiceExec.status.OK) return null;
      return data ?? null;
    } catch (e) { return null; }
  },

  // 260622: 내 위치(좌표) 저장 — 반경 전단지 발송 타겟용
  saveMyLocation: async ({ getters }, { latitude, longitude }) => {
    const userNo = getters['getUserData']?.userNo;
    if (!userNo) return false;
    const { status } = await ServiceExec.post(`/api/user/me/location?userNo=${userNo}&latitude=${latitude}&longitude=${longitude}`);
    return status === ServiceExec.status.OK;
  },

  signOut: async ({ commit, getters }) => {
    // 260916 정식배포 당일 운영 실사고(12:24~12:28, 웹 클라 1대가 PATCH /api/user/log/out 500 을 9,308회 = 초당 40건):
    //   ① 옛 persisted state 의 deviceInfo.syncDate:'' 같은 빈 문자열이 BE java.time 필드로 가면 uber-jar Jackson 섀도잉(NoSuchMethodError)으로 500
    //   ② 200 이 아니면 로컬 상태를 안 지워 /signin → /intro → signOut 이 무한 반복
    //   → 빈 문자열 키는 보내지 않고, 서버 응답과 무관하게 로컬 로그아웃은 반드시 끝내며, 진행 중이면 재진입하지 않는다.
    if (signOutInFlight) return;
    signOutInFlight = true;
    try {
      const userData = getters['getUserData'];
      const deviceInfo = getters['getDeviceInfo'] || {};
      const cleanDeviceInfo = {};
      Object.keys(deviceInfo).forEach(k => {
        if (deviceInfo[k] !== '') cleanDeviceInfo[k] = deviceInfo[k];
      });
      const payload = {
        deviceInfo: cleanDeviceInfo,
        userNo: userData.userNo
      };
      const res = await ServiceExec.patch(logOut, payload);
      if (res?.status !== ServiceExec.status.OK) console.warn('[signOut] 서버 로그아웃 실패(status=' + res?.status + ') — 로컬 로그아웃은 진행');
    } catch (e) {
      console.warn('[signOut] 서버 로그아웃 예외 — 로컬 로그아웃은 진행', e);
    } finally {
      // 260926: 푸시 토큰은 사람이 아니라 기기 것 — WEB 기본값으로 덮으면 앱을 끄지 않고 다시 로그인했을 때 보낼 토큰이 없다
      //   (네이티브는 부팅 때만 nativeSetDeviceInfo 를 준다). 서버 기기 행은 위 log/out 이 지웠으니 계정 연결(userNo·deviceNo)만 비운다.
      //   ⚠️ resetStoreOnLogout 이 user 모듈을 PRISTINE(WEB 기본값)으로 replaceState 한다 → 리셋 전에 떠 두고 리셋 뒤에 되돌린다(검수 260926).
      const dev = getters['getDeviceInfo'];
      const keepDevice = dev && dev.pushToken && dev.deviceType && dev.deviceType !== 'WEB' ? { ...dev, userNo: null, deviceNo: null } : null;
      commit('storeLogout');
      commit('setDeviceInfo');
      // 260515: 다른 도메인 모듈(business/card/memorial 등) state도 초기화. 계정 전환 시 누수 방지.
      resetStoreOnLogout();
      if (keepDevice) commit('setDeviceInfo', keepDevice); // 리셋 뒤 — 이 커밋이 localStorage 에도 다시 남긴다
      signOutInFlight = false;
    }
  },
  getAuthCode: async ({ commit, getters }) => {
    const phone = getters['getPhone'];
    const user = getters['getUserData'];

    const payload = {
      phone: phone,
      userNo: user?.userNo || null
    };
    const { status, data } = await ServiceExec.get('/api/user/auth/phone', payload);
    if (status !== ServiceExec.status.OK) return data;
    commit('setAuthCode', data);
    return true;
  },

  joinAuthCode: async ({ commit, getters }) => {
    const { phone, code } = getters['getPhoneInfo'];
    const { status, data } = await ServiceExec.get(joinAuthCode, { phone, code });
    if (status !== ServiceExec.status.OK) return data;
    // 260710 P0: 응답은 이제 Boolean(true) — 코드는 서버에만 저장. 클라 비교 폐지, 검증은 verifyPhoneCode로.
    return true;
  },

  // 260710 P0: 인증번호 서버 검증 — PhoneAuthInput 공통. 발송 방식(가입/찾기/변경) 무관하게 phone+입력코드로 서버 대조.
  verifyPhoneCode: async ({ getters }, inputCode) => {
    const { phone, code } = getters['getPhoneInfo'];
    const { status, data } = await ServiceExec.post(smsVerify, { phone, code, authCode: inputCode });
    return status === ServiceExec.status.OK && data === true;
  },

  updatePhoneAuthCode: async ({ commit, getters }, payload) => {
    const { userNo } = getters['getUserData'];
    const { status, data } = await ServiceExec.get(authCode, {
      phone: payload.phone,
      code: payload.code,
      userNo
    });
    if (status !== ServiceExec.status.OK) return data;
    commit('setAuthCode', data);
    return true;
  },

  findIdAuthCode: async ({ commit, getters }, payload) => {
    const phone = getters['getPhone'];
    const { status, data } = await ServiceExec.get(findIdAuthCode, payload);
    if (status !== ServiceExec.status.OK) return data;
    commit('setAuthCode', data);
    return true;
  },
  findPasswordAuth: async ({ commit, getters }, payload) => {
    console.log('findPasswordAuth :: ', payload);
    const { userId } = getters['getFindData'];
    const { status, data } = await ServiceExec.get(findPasswordCode, {
      ...payload,
      userId
    });
    if (status !== ServiceExec.status.OK) return data;
    commit('setAuthCode', data);
    return true;
  },
  renewAccessToken: async ({ commit, getters }) => {
    const { authNo } = getters['getUserData'] || '';
    const accessToken = getters['getAccessToken'] || '';
    const refreshToken = getters['getRefreshToken'] || '';

    if (!authNo || !accessToken || !refreshToken) return false;
    const { status, headers } = await ServiceExec.patch(renewAccessToken, { authNo, accessToken, refreshToken });
    if (status !== ServiceExec.status.OK) return false;

    commit('setAccessToken', headers[ACCESS_TOKEN_NAME]);
    commit('setRefreshToken', headers[REFRESH_TOKEN_NAME]);
    commit('ttlInit');
    return true;
  },
  // 260926 (0923 대표 회의 "회원가입 알림 안 온다" 추적): 앱 푸시 토큰 등록은 이 한 곳(PATCH renew/fcm-token)뿐인데,
  //   유일한 호출처 Main.vue 가 260916 홈 /intro 전환 뒤로 안 뜬다 → 로그아웃(24h 토큰 만료 자동 포함)으로 지워진 토큰이 다시 안 생겼다
  //   (운영 tblDevice 마지막 sync 09-16, 운영자 4명 중 3명 토큰 0). 호출처를 앱 부팅(nativeSetDeviceInfo)·로그인 성공으로 옮긴다.
  //   웹(토큰 없음)·비로그인은 보낼 게 없다. 빈 문자열 키는 BE java.time 필드 500(260916 signOut 사고)이라 뺀다. getter 객체는 직접 고치지 않는다.
  //   부팅(iOS 는 nativeSetDeviceInfo 가 두 번 올 수 있다)·로그인이 겹치면 두 요청이 동시에 '없음 → INSERT' 로 들어가 행이 둘 생긴다
  //   → 한 줄로 세운다(fcmRenewTail). 서버는 userNo 를 JWT 에서 쓴다(260926 — 바디 userNo 는 무시).
  renewFcmToken: ({ commit, getters }) => {
    const run = async () => {
      const device = getters['getDeviceInfo'] || {};
      const userNo = getters['getUserData']?.userNo;
      if (!device.pushToken || !userNo) return false;
      const payload = { userNo };
      Object.keys(device).forEach(k => {
        if (k !== 'userNo' && device[k] !== '') payload[k] = device[k];
      });
      const { status, data } = (await ServiceExec.patch(renewFcmToken, payload)) || {};
      if (status !== ServiceExec.status.OK) return false;
      commit('setDeviceInfo', data);
      return true;
    };
    fcmRenewTail = fcmRenewTail.then(run, run);
    return fcmRenewTail;
  },

  familyCodeSearch: async ({ commit, getters, state }, searchText) => {
    const payload = {
      searchText: searchText
    };
    const { status, data } = await ServiceExec.get(familyCodeSearch, payload);
    if (!status === ServiceExec.status.OK) return false;
    commit('setFamilyList', data.list ?? []);
  },
  emailDuplicated: async ({ commit, state }, email) => {
    if (isEmpty(email)) return false;
    const { status, data } = await ServiceExec.get(emailDuplicated, { email });
    if (!status === ServiceExec.status.OK) return false;
    commit('setDuplicated', data);
  },
  findId: async ({ commit, state, getters }) => {
    if (isEmpty(state.phone)) return false;

    const payload = {
      phone: state.phone,
      code: state.code
    };
    const { status, data } = await ServiceExec.get(findId, payload);
    if (status !== ServiceExec.status.OK || isEmpty(data)) return false;
    commit('setFindData', data);
    return true;
  },

  findAccounts: async ({ commit, state, getters }) => {
    if (isEmpty(state.phone)) return false;

    const payload = {
      phone: state.phone,
      code: state.code
    };
    const { status, data } = await ServiceExec.get(findId, payload);
    if (status !== ServiceExec.status.OK || isEmpty(data)) return false;
    commit('setFindAccounts', data);
    return true;
  },

  editUser: async ({ state, getters, commit }, payload) => {
    if (isEmpty(payload)) return false;
    const { userNo } = getters['getUserData'];
    payload.userNo = userNo;
    // const reqParams = new URLSearchParams(payload);
    const { status } = await ServiceExec.patch(updateUser, payload);
    if (status === ServiceExec.status.OK) {
      commit('setUserData', { ...getters['getUserData'], ...payload });
      return true;
    }
  },

  /**
   * 비밀번호 변경
   * @param state
   * @param getters
   * @param password
   * @return {Promise<boolean>}
   */
  editPassword: async ({ state, getters }, payload) => {
    if (isEmpty(payload.password)) return false;

    const form = getters['getFindData'];
    const { phone, userId } = form;

    const { status, data } = await ServiceExec.put(editPassword, payload);
    return status === ServiceExec.status.OK;
  },

  /**
   * 비밀번호 변경
   * @param state
   * @param getters
   * @param password
   * @return {Promise<boolean>}
   */
  editPasswordInMyPage: async ({ state, getters }, password) => {
    if (isEmpty(password)) return false;

    const user = getters['getUserData'];
    const { phone, userId } = user;

    const { status, data } = await ServiceExec.put(editPassword, { password: password, phone: phone, userId: userId });
    return status === ServiceExec.status.OK;
  },

  getItemCount: async ({ state, getters }) => {
    const { userNo } = getters['getUserData'];
    if (isEmpty(userNo)) return false;
    const { status, data } = await ServiceExec.get(userItemCount + userNo);
    if (status !== ServiceExec.status.OK) return false;
    return data;
  },
  getFamilyList: async ({ state, commit, getters }) => {
    const { userNo } = getters['getUserData'];
    const { status, data } = await ServiceExec.get(userFamilyList + userNo);
    if (status !== ServiceExec.status.OK) return false;
    commit('setFamilyList', data);
    return true;
  },
  editAgreePush: async ({ state, commit, getters }, isAgree) => {
    const { userNo } = getters['getUserData'];
    const { status } = await ServiceExec.put(editMarketing + userNo + `?isAgree=${isAgree}`);
    return status === ServiceExec.status.OK;
  },

  editAgreeBusinessMarketingPush: async ({ state, commit, getters }, isAgree) => {
    const { userNo } = getters['getUserData'];
    const { status } = await ServiceExec.put(editBusinessMarketing + userNo + `?isAgree=${isAgree}`);
    return status === ServiceExec.status.OK;
  },
  deathCertificate: async ({ state, commit, getters }, payload) => {
    const { userNo } = getters['getUserData'];
    const reqData = cloneDeep({ ...payload, userNo });
    fileRequestBinding(reqData);
    const formData = asFormData(reqData);
    const { status } = await ServiceExec.multiPost(deathCertificate, formData);
    return status === ServiceExec.status.OK;
  },

  userIdExists: async ({ state, commit }, userId) => {
    const { data, status } = await ServiceExec.get(userIdExists, { userId: userId });
    if (status !== ServiceExec.status.OK) return false;
    return data;
  },

  getIsUnRead: async ({ state, commit, getters }) => {
    const { userNo } = getters['getUserData'];
    if (isEmpty(userNo)) return false;

    const response = await ServiceExec.get('/api/notification/unread', { userNo });
    if (response?.status !== ServiceExec.status.OK) return false;
    commit('updateReadState', !response?.data);
    return true;
  },
  premiumNumberCheck: async ({ state }, couponNumber) => {
    const { data, status } = await ServiceExec.get(premiumNumberCheck(couponNumber));
    return status === ServiceExec.status.OK && data;
  },

  updateUserPremium: async ({ state }, payload) => {
    const { data, status } = await ServiceExec.get(updateUserPremium(payload.userNo, payload.couponNumber));
    return status === ServiceExec.status.OK && data;
  },
  versionCheck: async ({ state }, payload) => {
    const { data, status } = await ServiceExec.get(versionCheck, payload);
    return data;
  }
};
